import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import CapitalRaising from "@/pages/CapitalRaising";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import RequestDemo from "@/pages/RequestDemo";
import AuthCallback from "@/pages/AuthCallback";
import BillingSuccess from "@/pages/BillingSuccess";
import AppShell from "@/components/layout/AppShell";
import Dashboard from "@/pages/app/Dashboard";
import Onboarding from "@/pages/app/Onboarding";
import HealthScore from "@/pages/app/HealthScore";
import Einstein from "@/pages/app/Einstein";
import AgentPage from "@/pages/app/AgentPage";
import Assets from "@/pages/app/Assets";
import OrgAdmin from "@/pages/app/OrgAdmin";
import PlatformAdmin from "@/pages/app/PlatformAdmin";
import Judge from "@/pages/app/Judge";
import SuccessPredictor from "@/pages/app/SuccessPredictor";
import ProgramDirector from "@/pages/app/ProgramDirector";
import EconomicImpact from "@/pages/app/EconomicImpact";
import Billing from "@/pages/app/Billing";
import Security from "@/pages/app/Security";
import AuditLog from "@/pages/app/AuditLog";
import PlatformUsers from "@/pages/app/PlatformUsers";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/capital-raising" element={<CapitalRaising />} />
          <Route path="/request-demo" element={<RequestDemo />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/billing/success" element={<BillingSuccess />} />
          <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="health-score" element={<HealthScore />} />
            <Route path="einstein" element={<Einstein />} />
            <Route path="business-plan" element={<AgentPage agent="business_plan" title="AI Business Plan Builder" description="Investor-grade business plans generated from your Business DNA." />} />
            <Route path="auditor" element={<AgentPage agent="auditor" title="AI Business Auditor" description="Deep audit of your business with SWOT, risks, and improvement roadmap." />} />
            <Route path="marketing-plan" element={<AgentPage agent="marketing_plan" title="Marketing Strategy Generator" description="12-month marketing plan with channels, campaigns, and calendars." />} />
            <Route path="industry" element={<AgentPage agent="industry" title="Industry Intelligence" description="PESTLE, Porter's Five Forces, and competitive landscape." />} />
            <Route path="pitch" element={<AgentPage agent="pitch" title="Pitch Presentation Outliner" description="Full pitch outline, speaker notes, and 10 elevator angles." />} />
            <Route path="financials" element={<AgentPage agent="financials" title="Financial Modeling" description="3, 5, 7 and 10 year proforma with assumptions and sensitivity." />} />
            <Route path="capital" element={<AgentPage agent="capital_readiness" title="Capital Readiness" description="Funding readiness scorecard, recommended path, and investor checklist." />} />
            <Route path="assets" element={<Assets />} />
            <Route path="predictor" element={<SuccessPredictor />} />
            <Route path="program-director" element={<ProgramDirector />} />
            <Route path="economic-impact" element={<EconomicImpact />} />
            <Route path="billing" element={<Billing />} />
            <Route path="security" element={<Security />} />
            <Route path="platform/audit" element={<AuditLog />} />
            <Route path="platform/users" element={<PlatformUsers />} />
            <Route path="org-admin" element={<OrgAdmin />} />
            <Route path="judge" element={<Judge />} />
            <Route path="platform" element={<PlatformAdmin />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
